import styled from 'styled-components';

export default styled.div.attrs({
  className: 'page-container',
})`
  padding-top: 1px;
  grid-area: body;
  padding-bottom: ${({ padded }) => (padded ? '2rem' : '0')};
`;
